import * as React from 'react';

/**
 * @description ShoppingShop icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ShoppingShop } from '@sravni/design-system-icons'
 *
 * <ShoppingShop />
 * ```
 */
const ShoppingShop = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "ShoppingShop", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M4.252 9.075v8.333M17.219 9.075v8.333M12.588 17.407v-3.703a1.852 1.852 0 0 0-3.703 0v3.703M2.402 17.408H19.07M4.32 9.074c-1.416-.01-2.338-1.41-1.725-2.618l1.43-2.815C4.35 3 5.034 2.592 5.787 2.592h9.897c.751 0 1.436.408 1.762 1.05l1.43 2.814c.613 1.207-.309 2.608-1.724 2.618-1.18 0-2.138-.807-2.138-1.803v-.04c0 1.018-.958 1.843-2.139 1.843-1.18 0-2.138-.825-2.138-1.843 0 1.018-.957 1.843-2.138 1.843S6.46 8.249 6.46 7.23v.04c-.002.996-.96 1.803-2.14 1.803v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { ShoppingShop };
//# sourceMappingURL=ShoppingShop.js.map
